export const ROLES_APPLICATION = {
  ADMIN: 'Admin',
  ACCOUNTING_SOURCING: 'Abastecimiento_contabilidad',
  COORDINATOR_DELIVERIES: 'APP Abastecimiento - Carga Certificada - Coordinador',
  COORDINATOR_PROTOCOLS: 'APP Protocolos - Coordinador',
  ADMIN_PROTOCOLS: 'APP Protocolos - SuperAdmin',
  INSPECTOR_PROTOCOLS: 'APP Protocolos - Inspector',
  INSTALLER_PROTOCOLS: 'APP Protocolos - Instalador',
  VIRTUAL_STORES: 'Bodegas Moviles',
  REGISTERED_WITHOUT_ACCESS: 'APP Protocolos - Registrado sin acceso',
  BOLETA: 'Atención al Cliente - CI - Reporte Ahorro - Admin',
  BUDGET: 'Presupuesto C&I',
  PROJECTS_SEC: 'SEC - Admin',
  PROJECTS_SEC_SUPERADMIN: 'SEC - SuperAdmin',
  PROJECTS_SEC_RESIDENCIAL: 'SEC - Residencial',
  PROJECTS_SEC_CI: 'SEC - CI',
  ROLES_ADMIN: 'roles admin',
  EPP_SOLICITANTE: 'Solicitud de EPP - Solicitante',
  EPP_PREVENCIONISTA: 'Solicitud de EPP - Prevencionista',
  EPP_MESA_AYUDA: 'Solicitud de EPP - Mesa de ayuda',
  EPP_ASESOR_PREVENCIONISTA: 'Solicitud de EPP - Asesor Prevencionista',
  DISAGREEMENTS: 'Disconformidades',
  API_BANK_CHILE: 'API Bank Chile',
  FINANCE_PG: 'finanzas_pg',
  ACCOUNTING_PG: 'contabilidad_pg',
  MARCAJE_DE_ASISTENCIAS: 'Marcaje de Asistencias - Lider',
  PROFORMA_ANALISTA_OPERACIONES: 'Analista de operaciones(Proforma y facturación)',
  PROFORMA_JEFE_OPERACIONES: 'Jefe de operaciones(Proforma y facturación)',
  PROFORMA_ANALISTA_FINANZAS: 'Analista de finanzas(Proforma y facturación)',
  PROFORMA_JEFE_FINANZAS: 'Jefe de finanzas(Proforma y facturación)',
  PROFORMA_EXPERIENCIA_CLIENTES: 'Experiencia de clientes(Proforma y facturación)',
  SIPE_PM_EJECUCION: 'PM Ejecución(SIPE)',
  SIPE_LIDER_EJECUCION: 'Líder de ejecución(SIPE)',
  PAYMENTS_SEC_ENGINEER: 'Ingenieria (Modulo de pagos)',
  PAYMENTS_SEC_ACCOUNTING: 'Contabilidad (Modulo de pagos)',
  PAYMENTS_SEC_FINANCE: 'Finanzas (Modulo de pagos)'
}

export const ROLES_APPLICATION_MODULE = [
  {
    role: ROLES_APPLICATION.ADMIN_PROTOCOLS,
    all: true,
    module: [],
    moduleSub: [
      'menu.quality.business_unit.text',
      'menu.quality.mangement_area.text',
      'menu.quality.document_type.text',
      'menu.quality.disciplines.text',
      'menu.quality.documents.text',
      'menu.quality.users.text'
    ]
  },
  {
    role: ROLES_APPLICATION.COORDINATOR_PROTOCOLS,
    all: false,
    module: ['menu.quality.answers.text', 'menu.quality.projects.text', 'menu.quality.maintainers'],
    moduleSub: [
      'menu.quality.disciplines.text',
      'menu.quality.documents.text',
      'menu.quality.users.text'
    ]
  },
  {
    role: ROLES_APPLICATION.INSPECTOR_PROTOCOLS,
    all: false,
    module: ['menu.quality.answers.text', 'menu.quality.projects.text'],
    moduleSub: []
  },
  {
    role: ROLES_APPLICATION.INSTALLER_PROTOCOLS,
    all: false,
    module: [],
    moduleSub: []
  },
  {
    role: ROLES_APPLICATION.VIRTUAL_STORES,
    all: false,
    module: [
      'menu.supplying.maintainers.virtual_stores_consumption.text',
      'menu.supplying.maintainers.virtual_stores_consumption.reports',
      'menu.supplying.maintainers.virtual_stores_consumption.maintainer_stores'
    ],
    moduleSub: [
      'menu.supplying.maintainers.virtual_stores_consumption.text',
      'menu.supplying.maintainers.virtual_stores_consumption.reports',
      'menu.supplying.maintainers.virtual_stores_consumption.maintainer_stores'
    ]
  },
  {
    role: ROLES_APPLICATION.BOLETA,
    all: false,
    module: [
      'menu.customer_service.text',
      'menu.customer_service.c_and_i',
      'menu.customer_service.bills'
    ],
    moduleSub: [
      'menu.customer_service.text',
      'menu.customer_service.c_and_i',
      'menu.customer_service.bills'
    ]
  },
  {
    role: ROLES_APPLICATION.PROJECTS_SEC,
    all: false,
    module: ['Proyectos SEC'],
    moduleSub: []
  },
  {
    role: ROLES_APPLICATION.EPP_SOLICITANTE,
    all: false,
    module: ['Solicitud EPP', 'Solicitar EPP'],
    moduleSub: ['Solicitud EPP', 'Solicitar EPP']
  },
  {
    role: ROLES_APPLICATION.EPP_PREVENCIONISTA,
    all: false,
    module: ['Solicitud EPP', 'Solicitar EPP', 'Listado de solicitudes'],
    moduleSub: ['Solicitud EPP', 'Solicitar EPP', 'Listado de solicitudes']
  },
  {
    role: ROLES_APPLICATION.EPP_ASESOR_PREVENCIONISTA,
    all: false,
    module: ['Solicitud EPP', 'Solicitar EPP', 'Listado de solicitudes'],
    moduleSub: ['Solicitud EPP', 'Solicitar EPP', 'Listado de solicitudes']
  },
  {
    role: ROLES_APPLICATION.EPP_MESA_AYUDA,
    all: false,
    module: ['Solicitud EPP', 'Solicitar EPP', 'Configurar Prevencionista'],
    moduleSub: ['Solicitud EPP', 'Solicitar EPP', 'Configurar Prevencionista']
  },
  {
    role: ROLES_APPLICATION.ROLES_ADMIN,
    all: false,
    module: ['menu.managment_roles', 'menu.templates'],
    moduleSub: []
  },
  {
    role: ROLES_APPLICATION.ADMIN,
    all: false,
    module: ['menu.templates'],
    moduleSub: []
  },
  {
    role: ROLES_APPLICATION.DISAGREEMENTS,
    all: false,
    module: ['menu.disagreements.text'],
    moduleSub: []
  },
  {
    role: ROLES_APPLICATION.MARCAJE_DE_ASISTENCIAS,
    all: false,
    module: ['menu.quality.answers.text', 'menu.quality.projects.text', 'menu.quality.maintainers'],
    moduleSub: [
      'menu.quality.disciplines.text',
      'menu.quality.documents.text',
      'menu.quality.users.text'
    ]
  },
  {
    role: ROLES_APPLICATION.INSPECTOR_PROTOCOLS,
    all: false,
    module: ['menu.quality.answers.text', 'menu.quality.projects.text'],
    moduleSub: []
  },
  {
    role: ROLES_APPLICATION.INSTALLER_PROTOCOLS,
    all: false,
    module: [],
    moduleSub: []
  },
  {
    role: ROLES_APPLICATION.VIRTUAL_STORES,
    all: false,
    module: [
      'menu.supplying.maintainers.virtual_stores_consumption.text',
      'menu.supplying.maintainers.virtual_stores_consumption.reports',
      'menu.supplying.maintainers.virtual_stores_consumption.maintainer_stores'
    ],
    moduleSub: [
      'menu.supplying.maintainers.virtual_stores_consumption.text',
      'menu.supplying.maintainers.virtual_stores_consumption.reports',
      'menu.supplying.maintainers.virtual_stores_consumption.maintainer_stores'
    ]
  },
  {
    role: ROLES_APPLICATION.BOLETA,
    all: false,
    module: [
      'menu.customer_service.text',
      'menu.customer_service.c_and_i',
      'menu.customer_service.bills'
    ],
    moduleSub: [
      'menu.customer_service.text',
      'menu.customer_service.c_and_i',
      'menu.customer_service.bills'
    ]
  },
  {
    role: ROLES_APPLICATION.PROJECTS_SEC,
    all: false,
    module: ['menu.sec'],
    moduleSub: []
  },
  {
    role: ROLES_APPLICATION.PROJECTS_SEC_SUPERADMIN,
    all: false,
    module: [
      'menu.sec',
      'menu.interconnections.title',
      'menu.interconnections.residencial',
      'menu.interconnections.ci'
    ],
    moduleSub: [
      'menu.interconnections.title',
      'menu.interconnections.residencial',
      'menu.interconnections.ci'
    ]
  },
  {
    role: ROLES_APPLICATION.PROJECTS_SEC_RESIDENCIAL,
    all: false,
    module: ['menu.interconnections.residencial'],
    moduleSub: ['menu.interconnections.residencial']
  },
  {
    role: ROLES_APPLICATION.PROJECTS_SEC_CI,
    all: false,
    module: ['menu.interconnections.ci'],
    moduleSub: ['menu.interconnections.ci']
  },
  {
    role: ROLES_APPLICATION.EPP_SOLICITANTE,
    all: false,
    module: ['menu.epp.req', 'menu.epp.title'],
    moduleSub: ['menu.epp.req', 'menu.epp.title']
  },
  {
    role: ROLES_APPLICATION.EPP_PREVENCIONISTA,
    all: false,
    module: ['menu.epp.req', 'menu.epp.title', 'menu.epp.list'],
    moduleSub: ['menu.epp.req', 'menu.epp.title', 'menu.epp.list']
  },
  {
    role: ROLES_APPLICATION.EPP_ASESOR_PREVENCIONISTA,
    all: false,
    module: ['menu.epp.req', 'menu.epp.title', 'menu.epp.list'],
    moduleSub: ['menu.epp.req', 'menu.epp.title', 'menu.epp.list']
  },
  {
    role: ROLES_APPLICATION.EPP_MESA_AYUDA,
    all: false,
    module: ['menu.epp.req', 'menu.epp.title', 'menu.epp.conf'],
    moduleSub: ['menu.epp.req', 'menu.epp.title', 'menu.epp.conf']
  },
  {
    role: ROLES_APPLICATION.DISAGREEMENTS,
    all: false,
    module: ['menu.disagreements.text'],
    moduleSub: []
  },
  {
    role: ROLES_APPLICATION.ROLES_ADMIN,
    all: false,
    module: ['menu.managment_roles'],
    moduleSub: []
  },
  {
    role: ROLES_APPLICATION.PROFORMA_ANALISTA_OPERACIONES,
    all: false,
    module: ['menu.proforma_billing.text'],
    moduleSub: [
      'menu.proforma_billing.list',
      'menu.proforma_billing.invoices',
      'menu.proforma_billing.distribuidoras',
      'menu.proforma_billing.monitoring',
      'menu.proforma_billing.resumen_esco',
      'menu.proforma_billing.informes'
    ]
  },
  {
    role: ROLES_APPLICATION.PROFORMA_JEFE_OPERACIONES,
    all: false,
    module: ['menu.proforma_billing.text'],
    moduleSub: [
      'menu.proforma_billing.list',
      'menu.proforma_billing.invoices',
      'menu.proforma_billing.distribuidoras',
      'menu.proforma_billing.monitoring',
      'menu.proforma_billing.resumen_esco',
      'menu.proforma_billing.informes'
    ]
  },
  {
    role: ROLES_APPLICATION.PROFORMA_ANALISTA_FINANZAS,
    all: false,
    module: ['menu.proforma_billing.text'],
    moduleSub: [
      'menu.proforma_billing.list',
      'menu.proforma_billing.invoices',
      'menu.proforma_billing.distribuidoras',
      'menu.proforma_billing.monitoring',
      'menu.proforma_billing.resumen_esco',
      'menu.proforma_billing.informes'
    ]
  },
  {
    role: ROLES_APPLICATION.PROFORMA_JEFE_FINANZAS,
    all: false,
    module: ['menu.proforma_billing.text'],
    moduleSub: [
      'menu.proforma_billing.list',
      'menu.proforma_billing.invoices',
      'menu.proforma_billing.distribuidoras',
      'menu.proforma_billing.monitoring',
      'menu.proforma_billing.resumen_esco',
      'menu.proforma_billing.informes'
    ]
  },
  {
    role: ROLES_APPLICATION.PROFORMA_EXPERIENCIA_CLIENTES,
    all: false,
    module: ['menu.proforma_billing.text'],
    moduleSub: [
      'menu.proforma_billing.list',
      'menu.proforma_billing.invoices',
      'menu.proforma_billing.distribuidoras',
      'menu.proforma_billing.monitoring',
      'menu.proforma_billing.resumen_esco',
      'menu.proforma_billing.informes'
    ]
  },
  {
    role: ROLES_APPLICATION.SIPE_PM_EJECUCION,
    all: false,
    module: ['menu.banns', 'menu.rrhh_history', 'menu.rrhh'],
    moduleSub: ['menu.banns', 'menu.rrhh_history', 'menu.rrhh']
  },
  {
    role: ROLES_APPLICATION.SIPE_PM_EJECUCION,
    all: false,
    module: ['menu.sipe.text'],
    moduleSub: [
      'menu.sipe.kpi_ejecucion',
      'menu.sipe.gestion_kpi.text',
      'menu.sipe.gestion_kpi.kpi_subsanacion',
      'menu.sipe.gestion_kpi.kpi_csat',
      'menu.sipe.gestion_kpi.kpi_bono_total'
    ]
  },
  {
    role: ROLES_APPLICATION.SIPE_LIDER_EJECUCION,
    all: false,
    module: ['menu.sipe.text'],
    moduleSub: [
      'menu.sipe.kpi_ejecucion',
      'menu.sipe.gestion_kpi.text',
      'menu.sipe.gestion_kpi.kpi_subsanacion',
      'menu.sipe.gestion_kpi.kpi_csat',
      'menu.sipe.gestion_kpi.kpi_bono_total'
    ]
  },
  {
    role: ROLES_APPLICATION.BUDGET,
    all: false,
    module: ['menu.budge'],
    moduleSub: [
      'budge.tab_compare',
      'budge.tab_budget'
    ]
  }
]
